/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, October 2025
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import SpecifiedAttachmentsPanel from '../../components/SpecifiedAttachmentsPanel/SpecifiedAttachmentsPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { scroller } from "react-scroll";
import Select from 'react-select';
import loadingData from './loading';
import { InitialAttachmentsDict, btnStyle, redirectToSummary, przedmiotOchronyOptions } from './constants';
import { PanelStyle } from '../../constants';
import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
  type,
} = PanelStyle;


class UstaleniePomnikaOchronyPrzyrody extends React.Component {
  state = {
    objectList: [
      {
        przedmiotOchrony: null,
        przedmiotOchronyOther: null,
        selectedParcels: [],
        typeTree: null,
        circuit: null,
        height: null,
        condition: null,
        town: null,
        street: null,
        houseNr: null,
        locationDesc: null,
      }
    ],
    selectedParcels: [],
    selectedRoads: [],
    objectErrors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachmentsDict: InitialAttachmentsDict[this.props.serviceInfo.eservice.shortName] || {},
    attachments: [],
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  validators = {
    przedmiotOchrony: [v.NotSelected],
    przedmiotOchronyOther: [],
    circuit: [v.isNumber],
    height: [v.isNumber],
    town: [v.NotNull],
    locationDesc: [v.NotNull],
  };

  optionalValidators = {
    typeTree: [v.NotNull],
    circuit: [v.NotNull, v.isNumber],
    height: [v.NotNull, v.isNumber],
    condition: [v.NotNull],
  }

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });

    this.setState({ isMounted: true });
  }

  addObject = () => {
    this.setState({
      objectList: [...this.state.objectList, 
        {
          przedmiotOchrony: null,
          przedmiotOchronyOther: null,
          selectedParcels: [],
          typeTree: null,
          circuit: null,
          height: null,
          condition: null,
          town: null,
          street: null,
          houseNr: null,
          locationDesc: null,
        }
      ],
    }, this.validateObjects);
  }

  removeObject = (idx) => {
    const list = [...this.state.objectList];

    if (idx > -1) {
      list.splice(idx, 1);
    }

    this.setState({
      objectList: list
      }, this.validateObjects
    );
  }

  validateObjects = (group = null, field = null, index = null, callback = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateObjectField(group, field, index);
      newState = {
          objectErrors: {
            ...this.state.objectErrors,
            [`${field}${index}`]: checks
          }
      };
    } else {
      let errors = {};
      const grupy = ['objectList'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { objectErrors: errors };
    }

    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateObjectField = (group, field, index) => {
    const checks = [];
    let validators = this.validators;
    if (['typeTree', 'circuit', 'height', 'condition'].includes(field) && this.state[group][index].przedmiotOchrony == 'drzewo') {
      validators = this.optionalValidators;
    }
    if (Object.keys(validators).indexOf(field) > -1) {
      for (const validator of validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validateObjectField(group, field, idx);
          errors[`${field}${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };

  setParcels = (parcels, index, callback = null) => {
    const arr = this.state.objectList;
    arr[index].selectedParcels = parcels;

    this.setState({
      objectList: arr,
    });
  }

  onChangeObject = (e, state, elem, index) => {
    const arr = this.state[state];
    arr[index][elem] = e.target.value;

    this.setState({
      [state]: arr,
    }, () => this.validateObjects(state, elem, index));
  }

  onChangeObjectSelect = (e, state, elem, index) => {
    const arr = this.state[state];
    arr[index][elem] = e.value;

    this.setState({
      [state]: arr,
    }, () => this.validateObjects(state, elem, index));
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.objectErrors)) {
      if (this.state.objectErrors[key].length > 0) return true;
    }
    return false;
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  postValidation = () => {
    for (const obj of this.state.objectList) {
      if (obj.selectedParcels.length === 0) {
        const index = this.state.objectList.indexOf(obj);
        return this.setState({
          errorText: `Dla obiektu nr ${index + 1} nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki`,
          errorTitle: 'Błędnie wypełniony formularz',
          showError: true,
          loading: false,
        }, () => this.scrollToObject(`obj-containter-${index}`));
      }
    }

    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      return this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      return this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
    }

    this.props
      .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
        info: this.state.objectList,
        dzialki: this.state.selectedParcels,
        user: {
          ...this.props.serviceInfo.user,
        },
        selectedParcels: this.state.selectedParcels,
        shortName: this.props.serviceInfo.eservice.shortName,
        urzad: this.props.districts[this.props.prefix],
        attachments: this.state.attachments,
      })
      .then(resp => {
        this.setState({
          loading: false }, () =>
          redirectToSummary(resp.jobId));
      });
  };

  startService = () => {
    this.validateObjects(null, null, null, this.postValidation);
  };

  scrollToObject = (field) => {
    scroller.scrollTo(field, {
      duration: 250,
      delay: 50,
      smooth: true,
      offset: -200,
    });
  }

  getSelectWithError = (group, field, index, value, options) => (
    <div style={{ textAlign: 'justify' }}>
      <Select
        noResultsText={'brak wyników'}
        clearable={false}
        options={options}
        value={value}
        placeholder={'Wybierz z listy...'}
        onChange={e => this.onChangeObjectSelect(e, group, field, index)}
        style={{
          width: '100%',
          borderColor:
            Object.keys(this.state.objectErrors).indexOf(`${field}${index}`) > -1 &&
              this.state.objectErrors[`${field}${index}`] !== null &&
              this.state.objectErrors[`${field}${index}`].length > 0
              ? 'red'
              : '#ccc',
        }}
        onBlur={event => event.preventDefault()}
        optionClassName="needsclick"
        blurInputOnSelect={false}
      />
      {/* RENDER ERROS IN SPAN */}
      {Object.keys(this.state.objectErrors).indexOf(`${field}${index}`) > -1 &&
        this.state.objectErrors[`${field}${index}`] !== null &&
        this.state.objectErrors[`${field}${index}`].length > 0
        ? this.state.objectErrors[`${field}${index}`].map((val, index) => (
          <span key={index} style={errorSpanStyle}>
            {val}
          </span>
        ))
        : null}
    </div>
  )

  renderInput = (title, group, field, index, standardLayout=true) => {
    return (
      <div className="row mobile-row" style={rowStyle}>
        <div className={labelCol}>
          <label style={labelStyle}>{title}</label>
        </div>
        <div className={ standardLayout ? "col-sm-5" : "col-sm-7"}>
          <input
            name={field}
            style={{
              width: '100%',
              borderColor:
                Object.keys(this.state.objectErrors).indexOf(`${field}${index}`) > -1 &&
                  this.state.objectErrors[`${field}${index}`] !== null &&
                  this.state.objectErrors[`${field}${index}`].length > 0
                  ? 'red'
                  : '#ccc',
            }}
            className="form-control"
            value={this.state.objectList[index][field] ? this.state.objectList[index][field] : ''}
            onChange={e => this.onChangeObject(e, group, field, index)}
          />
          {/* RENDER ERROS IN SPAN */}
          {Object.keys(this.state.objectErrors).indexOf(`${field}${index}`) > -1 &&
            this.state.objectErrors[`${field}${index}`] !== null &&
            this.state.objectErrors[`${field}${index}`].length > 0
            ? this.state.objectErrors[`${field}${index}`].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
            : null}
        </div>
        <div className={ standardLayout ? "col-sm-4" : "col-sm-2"} />
      </div>
    )
  };

  renderTextArea = (title, group, field, index, standardLayout=true) => {
    return (
      <div className="row mobile-row" style={rowStyle}>
        <div className={labelCol}>
          <label style={labelStyle}>{title}</label>
        </div>
        <div className={ standardLayout ? "col-sm-5" : "col-sm-7"}>
          <textarea
            name={field}
            style={{
              width: '100%',
              borderColor:
                Object.keys(this.state.objectErrors).indexOf(`${field}${index}`) > -1 &&
                  this.state.objectErrors[`${field}${index}`] !== null &&
                  this.state.objectErrors[`${field}${index}`].length > 0
                  ? 'red'
                  : '#ccc',
            }}
            className="form-control"
            rows={3}
            value={this.state.objectList[index][field] ? this.state.objectList[index][field] : ''}
            onChange={e => this.onChangeObject(e, group, field, index)}
          />
          {/* RENDER ERROS IN SPAN */}
          {Object.keys(this.state.objectErrors).indexOf(`${field}${index}`) > -1 &&
            this.state.objectErrors[`${field}${index}`] !== null &&
            this.state.objectErrors[`${field}${index}`].length > 0
            ? this.state.objectErrors[`${field}${index}`].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
            : null}
        </div>
        <div className={ standardLayout ? "col-sm-4" : "col-sm-2"} />
      </div>
    )
  };

  renderBasicInfo = (title, obj, index) => (
    <div key={`obj-basic-info-${index}`}>
      <div className="row mobile-row" style={rowStyle} key={`obj-row${index}`}>
        <div className="col-sm-3">
          <label style={labelStyle}>{title}</label>
        </div>
        <div className="col-sm-5">
          {this.getSelectWithError('objectList', 'przedmiotOchrony', index, obj.przedmiotOchrony, przedmiotOchronyOptions)}
        </div>
        <div className="col-sm-2">
          <button
            type="button"
            className={'btn btn-primary'}
            style={{ float: 'right', width: '100%' }}
            onClick={() => this.scrollToObject(`obj-containter-${index}`)}
          >
              Uzupełnij
          </button>
        </div>
        <div className="col-sm-2">
          <button
            type="button"
            className={'btn btn-danger'}
            style={{ float: 'right', width: '100%' }}
            onClick={() => this.removeObject(index)}
            disabled={this.state.objectList.length <= 1}
          >
              - Usuń obiekt
          </button>
        </div>
      </div>
      {obj.przedmiotOchrony === 'inne' ?
        this.renderInput('Inny przedmiot ochrony:', 'objectList', 'przedmiotOchronyOther', index)
      : null}
    </div>
  )

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel title={'1. Lista obiektów'}>
          <div className="row mobile-row" style={rowStyle}>
            <div className="col-sm-10"></div>
            <div className="col-sm-2">
              <button
                type="button"
                className={'btn btn-success'}
                style={{ float: 'right', width: '100%' }}
                onClick={() => this.addObject()}
              >
                  + Dodaj obiekt
              </button>
            </div>
          </div>
          {this.state.objectList.map((value, index) => {
            return this.renderBasicInfo(`${index + 1}. Przedmiot ochrony:`, value, index)
          })}
        </GrayPanel>

        {this.state.objectList.map((value, index) => {
            let name = value.przedmiotOchrony ? value.przedmiotOchrony : null;
            if (value.przedmiotOchrony == 'inne') {
              name = value.przedmiotOchronyOther ? value.przedmiotOchronyOther : null
            }
            const title = name ? `Obiekt nr ${index + 1}: ${name}` : `Obiekt nr ${index + 1}`;

            return (
              <GrayPanel title={title} key={`obj-containter-${index}`}>
                <div id={`obj-containter-${index}`}></div>
                {value.przedmiotOchrony == 'drzewo' ? 
                  <div style={{ marginBottom: '60px' }}>
                    <label style={labelStyle}>Opis pomnika (w przypadku drzew):</label>
                    {this.renderInput('Gatunek:', 'objectList', 'typeTree', index, false)}
                    {this.renderInput('Obwód pierśnicy [cm] (130 cm od ziemi):', 'objectList', 'circuit', index, false)}
                    {this.renderInput('Szacunkowa wysokość [m]:', 'objectList', 'height', index, false)}
                    {this.renderTextArea('Stan zdrowotny i zauważone uszkodzenia:', 'objectList', 'condition', index, false)}
                  </div> : null
                }
                <label style={labelStyle}>Adres obiektu:</label>
                {this.renderInput('Miejscowość:', 'objectList', 'town', index, false)}
                {this.renderInput('Ulica:', 'objectList', 'street', index, false)}
                {this.renderInput('Numer domu:', 'objectList', 'houseNr', index, false)}
                {this.renderTextArea('Opis lokalizacji:', 'objectList', 'locationDesc', index, false)}

                <label style={{ ...labelStyle, marginTop: '60px'}}>Lokalizacja na mapie:</label>
                { renderHelpDesc(isMobile, isTablet) }
                <CustomizedMap
                  serviceType={this.props.serviceInfo.eservice.shortName}
                  setParcels={this.setParcels}
                  setSelectDzialki={this.setSelectDzialki}
                  selectedParcels={this.state.objectList[index].selectedParcels}
                  obreby={this.props.serviceInfo.precints}
                  district={this.props.districts[this.props.prefix]}
                  prefix={this.props.prefix}
                  mapState={this.props.mapstates[0]}
                  settings={this.props.serviceInfo.eservice.mapConfig}
                  dokumentType={this.props.serviceInfo.eservice}
                  pointSelection
                  showPdfExport
                  index={index}
                />
              </GrayPanel>
            )
        })}

        <GrayPanel title={'Informacja dla wnioskodawcy'}>
          <div className="row">
              <ul>
                <li>Przed wypełnieniem wniosku należy upewnić się czy drzewo nie jest już objęte ochroną.</li>
                <li>W przypadku większej liczby drzew (np. aleja, skupisko) do wniosku należy dołączyć spis pomiarów wszystkich drzew</li>
                <li>Zgłoszenia pomnika przyrody może dokonać każdy (zarówno osoby prywatne jak i szkoły czy stowarzyszenia) osobiście lub korespondencyjnie.</li>
              </ul>
          </div>
        </GrayPanel>

        <SpecifiedAttachmentsPanel attachmentsDict={this.state.attachmentsDict} onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

UstaleniePomnikaOchronyPrzyrody.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(UstaleniePomnikaOchronyPrzyrody),
);



// WEBPACK FOOTER //
// src/routes/eservices/UstaleniePomnikaOchronyPrzyrody.js